// Funzione per ottenere il titolo di un gruppo
function getGroupTitle(groupName, groupTitles = {}) {
    return groupTitles[groupName] || '';
}

// Funzione per formattare il titolo di un gruppo
function getGroupDisplayTitle(groupName, groupTitles = {}) {
    const savedTitle = getGroupTitle(groupName, groupTitles);
    if (savedTitle && savedTitle.trim() !== '') {
        return savedTitle;
    }
    return `Gruppo: ${groupName}`;
}

// Funzione per aggiornare il titolo di un gruppo (ora richiede setGroupTitles)
function updateGroupTitle(groupName, title, setGroupTitles) {
    if (typeof setGroupTitles === 'function') {
        setGroupTitles(prev => ({ ...(prev || {}), [groupName]: title }));
    }
}

export { getGroupTitle, getGroupDisplayTitle, updateGroupTitle };